import { createContext, useReducer } from 'react';

// declare AuthContext as a Context object
export const AuthContext = createContext();

const initialState = {
  allLista: [],
  allCarros: [],
  allComercias: [],
  allClassicos: [],
  allAutocaravanas: [],
  mobileHomes: [],
  allTractor: [],
  allLowcost: [],
  allRetoma: [],
  allNovos: [],
  allMotasNovas: [],
  allMotas: [],
  allBarcos: [],
  allPecas: [],
  allMotores: [],
  allAtrelados: [],
  allVendidos: [],
  codPontoVenda: 0,
  allinfo: [],
  infoPrincipal: [],
  ArrayDestaques: [],
  home: false,
  plugins: {},
  Pesquisa: '',
  ultimasEntradas: [],
  Destaques: '',
  vendidosLayout: [],
  Zonas: [],
  tipoListagem: [],
};

// reducer to manage auth state
const reducer = (prevState, action) => {
  switch (action.type) {
    case 'AddLista':
      return {
        ...prevState,
        allLista: action.list,
      };
    case 'AddCarros':
      return {
        ...prevState,
        allCarros: action.list,
      };
    case 'AddComercias':
      return {
        ...prevState,
        allComercias: action.list,
      };
    case 'AddClassicos':
      return {
        ...prevState,
        allClassicos: action.list,
      };
    case 'AddAutocaravanas':
      return {
        ...prevState,
        allAutocaravanas: action.list,
      };
    case 'AddMobileHomes':
      return {
        ...prevState,
        mobileHomes: action.list,
      };

    case 'AddTractor':
      return {
        ...prevState,
        allTractor: action.list,
      };
    case 'AddVendidos':
      return {
        ...prevState,
        allVendidos: action.list,
      };
    case 'AddLowcost':
      return {
        ...prevState,
        allLowcost: action.list,
      };
    case 'AddRetoma':
      return {
        ...prevState,
        allRetoma: action.list,
      };
    case 'AddNovos':
      return {
        ...prevState,
        allNovos: action.list,
      };
    case 'AddMotas':
      return {
        ...prevState,
        allMotas: action.list,
      };
    case 'AddMotasNovas':
      return {
        ...prevState,
        allMotasNovas: action.list,
      };
    case 'AddBarcos':
      return {
        ...prevState,
        allBarcos: action.list,
      };
    case 'AddPecas':
      return {
        ...prevState,
        allPecas: action.list,
      };
    case 'AddMotores':
      return {
        ...prevState,
        allMotores: action.list,
      };
    case 'AddAtrelados':
      return {
        ...prevState,
        allAtrelados: action.list,
      };
    case 'AddPontoVenda':
      return {
        ...prevState,
        codPontoVenda: action.value,
      };
    case 'AddInfo':
      return {
        ...prevState,
        allinfo: action.list,
      };
    case 'AddPrincipal':
      return {
        ...prevState,
        infoPrincipal: action.list,
      };

    case 'ExistHome':
      return {
        ...prevState,
        home: action.list,
      };
    case 'AddArrayDestaques':
      return {
        ...prevState,
        ArrayDestaques: action.list,
      };

    case 'AddPlugins':
      return {
        ...prevState,
        plugins: action.list,
      };

    case 'AddPesquisa':
      return {
        ...prevState,
        Pesquisa: action.list,
      };
    case 'AddUltimasEntradas':
      return {
        ...prevState,
        ultimasEntradas: action.list,
      };
    case 'AddVendidosLayout':
      return {
        ...prevState,
        vendidosLayout: action.list,
      };
    case 'AddDestaque':
      return {
        ...prevState,
        Destaques: action.list,
      };
    case 'AddOrdenacaoSeccoes':
      return {
        ...prevState,
        ordenacao: action.list,
      };
    case 'AddZonas':
      return {
        ...prevState,
        Zonas: action.list,
      };
    case 'AddTipoListagem':
      let apresentation = {};
      if (action.list.Carros.listagemTipo === 3) {
        apresentation = {
          number: 8,
          layout: {
            sm: 1,
            md: 1,
            lg: 1,
            xl: 1,
            xxl: 1,
          },
        };
      }
      if (action.list.Carros.listagemTipo === 2) {
        apresentation = {
          number: 6,
          layout: {
            sm: 1,
            md: 1,
            lg: 1,
            xl: 2,
            xxl: 2,
          },
        };
      }
      if (action.list.Carros.listagemTipo === 1) {
        apresentation = {
          number: 12,
          layout: {
            sm: 2,
            md: 2,
            lg: 3,
            xl: 3,
            xxl: action.list.Carros.listagemNumero,
          },
        };
      }
      if (action.list.Carros.listagemTipo === 4) {
        apresentation = {
          number: 9,
          layout: {
            sm: 2,
            md: 2,
            lg: 3,
            xl: 3,
            xxl: action.list.Carros.listagemNumero,
          },
        };
      }

      return {
        ...prevState,
        tipoListagem: { ...action.list, Carros: { ...action.list.Carros, apresentation } },
      };
    default:
      return initialState;
  }
};

export const AuthProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return <AuthContext.Provider value={{ state, dispatch }}>{children}</AuthContext.Provider>;
};

export default AuthContext;
